import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { FuseAnimate } from '@fuse'
import ReactTable from 'react-table'
import clsx from 'clsx'
import * as R from 'ramda'
import { Typography, Button, Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  trHover: {
    '& .rt-tr-group': {
      padding: '0px !important',
    },
    '& .rt-tr': {
      padding: '7px 0 !important',
    },
  },
  emptyContainer: {
    borderColor: 'rgba(0,0,0,0.05)',
    paddingLeft: 40,
    paddingRight: 40,
  },
  height: {
    minHeight: ({ isEmptyLoading }) => (isEmptyLoading ? '300px' : 'initial'),
  },
}))

const NoDataComponent = (props) => {
  const { isShow, text } = props
  const classes = useStyles()
  if (!isShow) return null

  return (
    <div
      className={clsx(
        classes.emptyContainer,
        'flex flex-col border-t-1 pt-24 pb-64',
      )}
    >
      <Typography variant="body1" className="text-center">
        {!text && <FormattedMessage id="defaultTable.searchnotfound" />}
        {text}
      </Typography>
    </div>
  )
}

const Pagination = (props) => {
  const {
    canNext,
    canPrevious,
    defaultPageSize,
    onPageChange,
    onPageSizeChange,
    page,
    pageSize,
    pageSizeOptions,
    loading,
    total,
  } = props
  const _pageSize = Number(pageSize || defaultPageSize)
  const offset = page * _pageSize
  const totalItem = total || 0
  const fromItem = offset + 1
  const toItem = R.min(offset + _pageSize, total)
  const isLoading = total === undefined || loading
  if (!isLoading && totalItem === 0) {
    return null
  }

  return (
    <div>
      <div className="-pagination">
        <div className="-previous">
          <Button
            disabled={!canPrevious}
            onClick={() => onPageChange(page - 1)}
          >
            <Icon>chevron_left</Icon>
          </Button>
        </div>
        <div className="-center">
          {isLoading && (
            <div className="-pageInfo">
              <FormattedMessage id="dataTable.pagination.loading" />
            </div>
          )}
          {!isLoading && (
            <>
              <div className="-pageInfo">
                <FormattedMessage
                  id="dataTable.pagination.pageInfo"
                  values={{
                    from: fromItem,
                    to: toItem,
                    total: totalItem,
                  }}
                />
              </div>
              <div className="select-wrap -pageSizeOptions">
                <select
                  value={_pageSize}
                  onChange={(e) =>
                    onPageSizeChange(
                      Number(e.target.value || defaultPageSize),
                      page,
                    )
                  }
                >
                  {R.map(
                    (option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ),
                    pageSizeOptions,
                  )}
                </select>
              </div>
            </>
          )}
        </div>
        <div className="-next">
          <Button disabled={!canNext} onClick={() => onPageChange(page + 1)}>
            <Icon>chevron_right</Icon>
          </Button>
        </div>
      </div>
    </div>
  )
}

const DataTable = (props) => {
  const classes = useStyles({
    isEmptyLoading:
      R.compose(R.isEmpty, R.propOr([], 'data'))(props) && props.loading,
  })
  return (
    <FuseAnimate animation="transition.slideUpIn" delay={300}>
      <ReactTable
        NoDataComponent={() => (
          <NoDataComponent
            text={props.noDataText}
            isShow={R.isEmpty(props.data)}
          />
        )}
        {...props}
        showPaginationTop={props.showPagination && true}
        showPaginationBottom={false}
        minRows={0}
        className={clsx(
          classes.height,
          classes.trHover,
          '-highlight overflow-hidden',
          props.className,
        )}
        PaginationComponent={Pagination}
        pageSizeOptions={
          props.pageSizeOptions ?? [5, 10, 20, 25, 50, 100, 500, 1000, 2000]
        }
      />
    </FuseAnimate>
  )
}

export default React.memo(DataTable)
